import Papa, { ParseResult } from "papaparse";

import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";
import { detectCsvDelimiter } from "../../services/UtilityService";
import { ModuleImportRow } from "./ModuleUserImport.d";

export const REQUIRED_COLUMNS = ["user_emails", "module_ids"];

export const parseCsvFile = (
  file: File,
  setCsvData: React.Dispatch<React.SetStateAction<ModuleImportRow[]>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  language: string
) => {
  setLoading(true);
  detectCsvDelimiter(file).then((delimiter) => {
    Papa.parse<ModuleImportRow>(file, {
      header: true,
      skipEmptyLines: true,
      delimiter: delimiter,
      complete: (results: ParseResult<ModuleImportRow>) => {
        setLoading(false);
        if (results.errors.length > 0) {
          alert(translate(language, "PAGES.MODULE_IMPORT.ERRORS.CSV_IMPORT"));
          return;
        }
        if (!results.meta.fields || REQUIRED_COLUMNS.some((col) => !results.meta.fields!.includes(col))) {
          alert(translate(language, "PAGES.MODULE_IMPORT.ERRORS.MISSING_COLUMNS"));
          return;
        }
        setCsvData(results.data);
      },
      error: (error: Error) => {
        setLoading(false);
        alert(translate(language, "PAGES.MODULE_IMPORT.ERRORS.CSV_PARSING"));
        console.error("CSV Parsing Error:", error);
      },
    });
  });
};

export const submitModulesImport = (
  csvData: ModuleImportRow[],
  setSubmitting: Function,
  fileInputRef: React.RefObject<HTMLInputElement>,
  setCsvData: Function,
  requiredColumns: string[],
  language: string,
  showAlert?: Function,
  popAlert?: Function
) => {
  if (csvData.length === 0) return;
  setSubmitting(true);

  const blob = new Blob(
    [[requiredColumns.join(";"), ...csvData.map((row) => `${row.user_emails};${row.module_ids}`)].join("\n")],
    { type: "text/csv" }
  );
  const formData = new FormData();
  formData.append("file", blob, "modules_import.csv");

  showAlert?.({
    type: "info",
    title: translate(language, "PAGES.MODULE_IMPORT.ALERTS.IMPORTING_TITLE"),
    message: translate(language, "PAGES.MODULE_IMPORT.ALERTS.IMPORTING_MESSAGE"),
    clickOutsideToClose: false,
    buttons: [],
  });

  ApiService.post("modules/users/batch", formData)
    .then(() => {
      popAlert?.();
      showAlert?.({
        type: "success",
        title: translate(language, "PAGES.MODULE_IMPORT.ALERTS.SUCCESS_TITLE"),
        message: translate(language, "PAGES.MODULE_IMPORT.ALERTS.SUCCESS_MESSAGE"),
        clickOutsideToClose: true,
        buttons: [
          {
            label: translate(language, "PAGES.MODULE_IMPORT.ALERTS.BTN_OK"),
            onClick: () => popAlert?.(),
          },
        ],
      });
      setCsvData([]);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    })
    .catch((err: any) => {
      popAlert?.();
      showAlert?.({
        type: "danger",
        title: translate(language, "PAGES.MODULE_IMPORT.ALERTS.ERROR_TITLE"),
        message: err?.data?.message || translate(language, "PAGES.MODULE_IMPORT.ALERTS.ERROR_MESSAGE"),
        clickOutsideToClose: true,
        buttons: [
          {
            label: translate(language, "PAGES.MODULE_IMPORT.ALERTS.BTN_CLOSE"),
            variant: "danger",
            onClick: () => popAlert?.(),
          },
        ],
        extraContent: err?.data ? (
          <pre className="text-start off-white-background p-2 rounded border">{JSON.stringify(err.data, null, 2)}</pre>
        ) : null,
      });
    })
    .finally(() => {
      setSubmitting(false);
    });
};
